import { IAuthenticatedUserInfo, IExchangeTokenApiOutput, IImplicitCredentials, LocalStorageCacheWithExpiry } from '@notes/webintegrations-common'
import { Log } from './logger/Log'

const getEpochNowInSeconds = () => Date.now() / 1000
const thirtyMinutesInSeconds = 1800
const getDefaultEpochExpiryInSeconds = () => getEpochNowInSeconds() + thirtyMinutesInSeconds

// For now, even though we get back expires_in from implicit grant, we just hardcode an expiry threshold for simplicity
// TODO (machiam) Set up default caches in the lib so that we don't use different values per integration (I believe they can and should be shared)
export const userInfoCacheConstantKey = 'UserInfo'

// userInfoCache is used in first party sso flow as well. We remember userInfoCache for the agave host to know which upn (or account) Sticky Notes
// have been using in past sessions. Without userInfoCache, the first party sso flow will fallback to an active account.
export const userInfoCache = new LocalStorageCacheWithExpiry<IAuthenticatedUserInfo>(userInfoCacheConstantKey, getDefaultEpochExpiryInSeconds)

export const userPhotoCache = new LocalStorageCacheWithExpiry<string>(userInfoCacheConstantKey, getDefaultEpochExpiryInSeconds)
export const exchangeTokenCache = new LocalStorageCacheWithExpiry<IExchangeTokenApiOutput>('ExchangeToken', getDefaultEpochExpiryInSeconds)
export const implicitAuthCache = new LocalStorageCacheWithExpiry<IImplicitCredentials>('ImplicitAuth', getDefaultEpochExpiryInSeconds)

export function clearCaches(): void {
  Log.logger.warn('clearing local storage tokens')
  userInfoCache.clear()
  exchangeTokenCache.clear()
  implicitAuthCache.clear()
}
